import { render, staticRenderFns } from "./VowelsTestDev.vue?vue&type=template&id=f50a0518&scoped=true&"
import script from "./VowelsTestDev.vue?vue&type=script&lang=js&"
export * from "./VowelsTestDev.vue?vue&type=script&lang=js&"
import style0 from "./VowelsTestDev.vue?vue&type=style&index=0&id=f50a0518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50a0518",
  null
  
)

export default component.exports